module.exports = __webpack_public_path__ + "static/media/maxSuccessionLosses_80_90.0d8baa60.png";